<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-top: 10px;margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>全流程安全生产</el-breadcrumb-item>
        <el-breadcrumb-item>变更管理</el-breadcrumb-item>
        <el-breadcrumb-item>变更列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div><el-button type="primary" @click="handleAdd()" size="small">新建</el-button></div>
    </div>
    <div class="content">
      <div style="display: flex;width: 100%;justify-content: space-between;">
        <el-select
          v-model="modifyType"
          placeholder="变更类别"
          clearable
          size="small"
          @change="changeValue"
        >
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select
          v-model="sourceTypeId"
          placeholder="状态"
          clearable
          size="small"
          @change="changeValue1"
        >
          <el-option v-for="item in arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <Input
          search
          enter-button
          placeholder=" 请输入变更项目，项目编号，变更类型"
          v-model="fileNameOrTag"
          @on-search="getData(1)"
          style="width: 300px"
        />
      </div>
      <div style="margin-top: 20px;">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="termNum" label="项目编号">
            <template slot-scope="scope">
              <el-link type="primary" size="mini" @click.native.prevent="showData(scope.row)">
                <span>{{ scope.row.termNum }}</span>
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="termName" label="变更项目"></el-table-column>

          <el-table-column prop="modifyType" label="变更类别">
            <template slot-scope="scope">
              <span v-if="scope.row.modifyType == 0">工艺变更</span>
              <span v-if="scope.row.modifyType == 1">机械设备变更</span>
              <span v-if="scope.row.modifyType == 2">管理变更</span>
              <span v-if="scope.row.modifyType == 3">其它</span>
            </template>
          </el-table-column>
          <el-table-column prop="creatorName" label="申请人"></el-table-column>
          <el-table-column prop="gmtCreate" label="申请日期"></el-table-column>
          <el-table-column prop="modifyCause" label="变更原因"></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">待审批</span>
              <span v-if="scope.row.status == 1">部门领导审批</span>
              <span v-if="scope.row.status == 2">主管部门领导审批</span>
              <span v-if="scope.row.status == 3">实施人员审批</span>
              <span v-if="scope.row.status == 4">公司领导审批</span>
              <span v-if="scope.row.status == 5">待验收</span>
              <span v-if="scope.row.status == 6">已验收</span>
            </template>
          </el-table-column>
          <el-table-column prop="oper" label="操作" width="180">
            <template slot-scope="scope">
              <div slot="reference" class="name-wrapper">
                <el-link type="primary" @click="handRead(scope.row.id)" style="margin-right: 3px">审批</el-link>
                <span style="margin-right: 3px">|</span>
                <el-link
                  type="primary"
                  @click="handChange(scope.row.id,scope.row)"
                  v-if="scope.row.status < 1"
                  style="margin-right: 3px"
                >编辑</el-link>
                <span v-if="scope.row.status < 1" style="margin-right: 3px">|</span>
                <el-link type="danger" @click="handleDel(scope.row)" style="margin-right: 3px">删除</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;text-align: right">
          <Page :total="total" :page-size="sizePage" @on-change="getData" />
        </div>
      </div>
    </div>
    <!-- 点击项目编号的抽屉 -->
    <el-drawer :visible.sync="drawer" direction="rtl" :show-close="false" :before-close="handleClose" size="60%">
      <div slot="title" class="drawerTitle">
        <p>项目编号：{{ infoForm.termNum }}
          <i class="el-icon-circle-close" @click="handleClose"></i>
        </p>
        <div class="tWord">
          <div><p>变更类别</p><span>
            <span v-if="infoForm.modifyType == 0">工艺变更</span>
            <span v-if="infoForm.modifyType == 1">机械设备变更</span>
            <span v-if="infoForm.modifyType == 2">管理变更</span>
            <span v-if="infoForm.modifyType == 3">其它</span> 
          </span></div>
          <div><p>申请日期</p><span>{{ infoForm.gmtCreate }}</span></div>
        </div>
      </div>
      <div class="drawerBody">
        <el-tabs v-model="activeName">
          <el-tab-pane label="变更详情" name="a"></el-tab-pane>
        </el-tabs>
        <div class="bodyInner">
          <el-form
            :inline="true"
            :model="infoForm"
            class="demo-form-inline"
            style="background-color: white;overflow:auto;height: 500px"
          >
            <el-form-item label="变更项目：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.termName}}</span>
            </el-form-item>
            <el-form-item label="项目编号：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.termNum}}</span>
            </el-form-item>
            <el-form-item label="变更类别：" style="width: 40%;margin-left: 8%">
              <span v-if="infoForm.modifyType == 0">工艺变更</span>
              <span v-if="infoForm.modifyType == 1">机械设备变更</span>
              <span v-if="infoForm.modifyType == 2">管理变更</span>
              <span v-if="infoForm.modifyType == 3">其它</span>
            </el-form-item>
            <el-form-item label="申请部门：" style="width: 40%;margin-left: 5%">
              <span size="small" v-if="infoForm.departmentVo">{{infoForm.departmentVo.name}}</span>
            </el-form-item>
            <el-form-item label="变更内容：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.contentHtml}}</span>
            </el-form-item>
            <el-form-item label="变更原因：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.modifyCause}}</span>
            </el-form-item>
            <el-form-item label="部门领导：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.depLeaderName}}</span>
            </el-form-item>
            <el-form-item label="主管部门领导：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.depSupervisorName}}</span>
            </el-form-item>
            <el-form-item label="实施人员：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.executorName}}</span>
            </el-form-item>
            <el-form-item label="公司领导：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.companyLeaderName}}</span>
            </el-form-item>
            <el-form-item label="风险分析以风险措施：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.riskAnalysis}}</span>
            </el-form-item>
            <el-form-item label="变更方案：" style="width: 40%;margin-left: 5%">
              <el-link
                v-for="(item1,index) in trainStuff"
                type="primary"
                @click="linkDownload(item1.response.data,item1.name)"
                :key="index"
              >{{item1.name}}&nbsp;&nbsp;&nbsp;</el-link>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-drawer>

    <!-- 点击审批的抽屉 -->
    <el-drawer :visible.sync="drawer2" direction="rtl" :before-close="handleClose2" size="70%">
      <span slot="title">
        <div style="margin-left: 1%">
          <span style="font-size: 20px">
            <b>{{infoForm.termNum}}</b>
          </span>
        </div>
        <div style="margin-top: 1%;margin-left: 1%">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <b>变更项目</b>
              </div>
              <div class="grid-content bg-purple" style="margin-top: 3%">
                <span>{{spObj.termName}}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <b>变更类别</b>
              </div>
              <div class="grid-content bg-purple" style="margin-top: 3%">
                <span v-if="spObj.modifyType === 0">变更工艺</span>
                <span v-if="spObj.modifyType === 1">机械设备变更</span>
                <span v-if="spObj.modifyType === 2">管理变更</span>
                <span v-if="spObj.modifyType === 3">其它</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <b>申请日期</b>
              </div>
              <div class="grid-content bg-purple" style="margin-top: 3%">
                <span>{{spObj.gmtCreate}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </span>
      <div style="background-color: #e9eef3;height: 95%;margin-top: 1%">
        <el-tabs v-model="activeName" style="margin-left: 2%">
          <el-tab-pane label="审批详情" name="a">
            <div style="width: 99%;background:white;padding:30px 0">
              <el-steps :active="spObj.status" align-center style="width: 100%">
                <el-step title="部门领导意见">
                  <template slot="description">
                    <div v-if="spObj.status > 0">
                      <div>{{ spObj.leaderApproveTime }}</div>
                      <div>{{ spObj.leader_name }}</div>
                      <div>{{ spObj.leaderDepOpinion }}</div>
                    </div>
                  </template>
                </el-step>
                <el-step title="主管部门意见">
                  <template slot="description">
                    <div v-if="spObj.status > 1">
                      <div>{{ spObj.supervisorApproveTime }}</div>
                      <div>{{ spObj.supervisor_name }}</div>
                      <div>{{ spObj.supervisorOpinion }}</div>
                    </div>
                  </template>
                </el-step>
                <el-step title="实施人员意见">
                  <template slot="description">
                    <div v-if="spObj.status > 2">
                      <div>{{ spObj.executorApproveTime }}</div>
                      <div>{{ spObj.executor_name }}</div>
                      <div>{{ spObj.executorOpinion }}</div>
                    </div>
                  </template>
                </el-step>
                <el-step title="公司领导意见">
                  <template slot="description">
                    <div v-if="spObj.status > 3">
                      <div>{{ spObj.companyApproveTime }}</div>
                      <div>{{ spObj.company_leader_name }}</div>
                      <div>{{ spObj.companyOpinion }}</div>
                    </div>
                  </template>
                </el-step>
              </el-steps>
              <el-divider content-position="center"></el-divider>
              <div
                v-if="(spObj.status == 0 && userId == spObj.depLeaderId) || (spObj.status == 1 && userId == spObj.depSupervisorId)
                           || (spObj.status == 2 && userId == spObj.executorId) || (spObj.status == 3 && userId == spObj.companyLeaderId)"
              >
                <div style="width: 95%;padding-left: 100px">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"></el-input>
                </div>
                <div style="text-align:center;margin-top: 15px">
                  <el-button size="small" @click="back" v-if="spObj.status > 0">回退</el-button>
                  <el-button size="small" @click="submitSp">提交</el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import axios from "axios";
import { getSpDetail, submitSpA, backScroll } from "@/api/processManager";
export default {
  data() {
    return {
      activeName: "a",
      infoForm: { departmentVo: { name: "" } },
      drawer: false,
      drawer2: false,
      textarea: "",
      trainStuff: [
        {
          name: "",
          response: { data: "" }
        }
      ],
      dealId: "",
      dialogVisible: false,
      total: 10,
      sizePage: 10,
      currentPage: 1,
      tableData: [],
      sourceTypeId: "",
      modifyType: "",
      fileNameOrTag: "",
      arr: [
        // 0_ 待审批，1_ 部门领导审批,2_ 主管部门领导审批,3_ 实施人员审批，4_ 公司领导审批,5_ 待验收,6_ 已验收
        { value: "0", label: "待审批" },
        { value: "1", label: "部门领导审批" },
        { value: "2", label: "主管部门领导审批" },
        { value: "3", label: "实施人员审批" },
        { value: "4", label: "公司领导审批" },
        { value: "5", label: "待验收" },
        { value: "6", label: "已验收" }
      ],
      options: [
        // 变更类别0_工艺变更,1_机械设备变更,2_ 管理变更,3_ 其他
        { value: "0", label: "工艺变更" },
        { value: "1", label: "机械设备变更" },
        { value: "2", label: "管理变更" },
        { value: "3", label: "其他" }
      ],
      spObj: {},
      userId: ""
    };
  },
  created() {
    this.userId = localStorage.getItem("userId");
  },
  mounted: function() {
    this.getData(1);
  },
  methods: {
    showData(row) {
      this.trainStuff = [];
      this.componentsMoudel.httpRequest
        .getRequestHander("/modifyform/info/" + row.id)
        .openLoad()
        .startGet()
        .then(res => {
          this.infoForm = { ...res.body.data };
          let files = JSON.parse(this.infoForm.programFile);
          if (files) {
            for (var i = 0; i < files.length; i++) {
              let myFile = {};
              var file = files[i];
              myFile.response = {};
              myFile.response.data = file.url;
              myFile.name = file.fileName;
              this.trainStuff.push(myFile);
            }
          }
          this.drawer = true;
        });
    },
    handleClose() {
      this.drawer = false;
    },
    handleClose2() {
      this.drawer2 = false;
      this.getData(this.currentPage);
    },
    // 审核的按钮
    handRead(id) {
      // console.log(id)
      this.dealId = id;
      this.drawer2 = true;
      getSpDetail(id).then(res => {
        this.spObj = { ...res.body.data };
      });
    },
    // 提交审核
    submitSp() {
      if (this.textarea === "") {
        this.$message.error("请输入审核意见");
        return;
      }
      submitSpA({
        modifyFormId: this.spObj.id,
        modifyAudit: this.textarea
      }).then(res => {
        this.$message.success("提交成功");
        this.handRead(this.dealId);
        this.textarea = "";
      });
    },
    // 回退审核
    back() {
      backScroll({ modifyFormId: this.spObj.id }).then(res => {
        this.$message.success("回退成功");
        this.handRead(this.dealId);
        this.textarea = "";
      });
    },
    changeValue(val) {
      this.modifyType = val;
      this.getData(1);
    },
    changeValue1(val) {
      this.sourceTypeId = val;
      this.getData(1);
    },
    // sureClick(){
    //     let formData = new FormData();
    //     formData.append("id",this.dealId);
    //     formData.append("content",this.content);
    //     this.$message({
    //         showClose: true,
    //         message: "审批成功",
    //         type: "success",
    //     });
    //     this.dialogVisible = false;
    //     // this.componentsMoudel.httpRequest
    //     //     .getRequestHander(url)
    //     //     .openLoad()
    //     //     .startGet()
    //     //     .then((res) => {
    //     //         this.tableData = res.body.data;
    //     //         this.currentPage = res.body.page;
    //     //         this.total = res.body.cum;
    //     //         this.pageTotal = res.body.pageTotal;
    //     //     });
    // },
    getData(page) {
      this.currentPage = page;
      this.componentsMoudel.httpRequest
        .getRequestHander(
          this.componentsMoudel.getData("urls").getmodifyform +
            "?limit=" +
            this.sizePage +
            "&curPage=" +
            page +
            "&searchParam=" +
            this.fileNameOrTag +
            "&status=" +
            this.sourceTypeId +
            "&modifyType=" +
            this.modifyType
        )
        .openLoad()
        .startGet()
        .then(res => {
          this.tableData = res.body.data;
          // this.currentPage = res.body.page;
          this.total = res.body.cum;
          this.pageTotal = res.body.pageTotal;
        });
    },
    handleSizeChange(val) {
      this.sizePage = val;
      this.getEmployeeList(this.currentPage, this.sizePage);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getEmployeeList(this.currentPage, this.sizePage);
    },
    handleAdd() {
      this.$router.push({
        path: "/processManager/addModiftList"
      });
    },
    handChange(id, row) {
      this.$router.push({
        name: "addModiftList",
        params: { key: row }
      });
    },
    handleDel(row) {
      this.componentsMoudel.httpRequest
        .getRequestHander("/modifyform/delete/" + row.id)
        .openLoad()
        .startPost(this.ruleForm)
        .then(res => {
          if (this.currentPage > 1 && this.tableData.length <= 1) {
            this.currentPage -= 1;
          }
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success"
          });
          this.getData(this.currentPage);
        });
    },
    // 右边抽屉点击文件名字后下载文件
    linkDownload(val, val2) {
      let url = this.host + val; // host在main.js里面
      axios({
        method: "get",
        url: url,
        responseType: "blob"
      })
        .then(res => {
          if ("download" in document.createElement("a")) {
            let url1 = window.URL.createObjectURL(res.data);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url1;
            link.setAttribute("download", val2);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            navigator.msSaveBlob(res.data, val2);
          }
        })
        .catch(err => {
          this.$Message.error(err);
        });
    }
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 280px)
}
/* <!--         抽屉样式           --> */
.drawerTitle {
  box-shadow: 0px 5px 5px -5px black;
  height: 120px;
  padding: 0 15px
}
.drawerTitle > p {
  color: #000000;
  font-size: 18px;
  line-height: 55px;
}
.drawerTitle > p > i {
  font-size: 30px;
  float: right;
  margin: 15px 10px 0 0;
}
.drawerTitle > p > i:hover {
  color: #409EFF
}
.el-drawer__header {
  padding: 0 15px;
  margin-bottom: 0
}

/* 解决tab切换会有蓝色边框的问题 */ 
.chemicalInfoBox /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
box-shadow: none;
border-top-left-radius: 20px;
border-top-right-radius: 20px;
}

/*  */

.tWord {
  display: flex
}
.tWord div > p {
  font-size: 15px;
  line-height: 25px
}
.tWord div > span {
  color: #000000
}
.tWord div {
  width: 220px
}
.drawerBody {
  width: 100%;
  height: calc(100vh - 160px);
  background: rgb(247,247,247);
  overflow: hidden;
  padding: 10px 20px 20px;
}
.bodyInner {
  background: white;
  height: calc(100% - 60px);
  width: 100%;
  border: 1px solid #eaeaea;
  overflow: scroll;
}
</style>
